import { createContext, ReactNode, useCallback, useContext, useState } from "react";

type LightboxContextType = {
  isOpen: boolean;
  src: string | undefined;
  alt: string | undefined;
  openLightbox: (src: string, alt: string) => void;
  closeLightbox: () => void;
};

const LightboxContext = createContext<LightboxContextType | undefined>(undefined);

export function LightboxProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [src, setSrc] = useState<string | undefined>(undefined);
  const [alt, setAlt] = useState<string | undefined>(undefined);

  const openLightbox = useCallback((src: string, alt: string) => {
    setIsOpen(true);
    setSrc(src);
    setAlt(alt);
  }, []);

  const closeLightbox = useCallback(() => {
    setIsOpen(false);
    setSrc(undefined);
    setAlt(undefined);
  }, []);

  return (
    <LightboxContext.Provider
      value={{
        isOpen,
        src,
        alt,
        openLightbox,
        closeLightbox,
      }}
    >
      {children}
    </LightboxContext.Provider>
  );
}

export function useLightbox() {
  const context = useContext(LightboxContext);
  if (context === undefined) {
    throw new Error("useLightbox must be used within a LightboxProvider");
  }
  return context;
}
